import type { ParentRegistration } from '@leangap/types'
import { post } from './api'
import { ContactResponseSchema } from '@leangap/types'
import { PATHS } from './endpoints'

type ParentResponse = { success: boolean; message: string }

export async function submitParentRegistration(data: ParentRegistration) {
	return post<ParentResponse>(PATHS.parent, data, ContactResponseSchema)
}
